import React from 'react';

const HeroSection = () => {
  const scrollToHowItWorks = (e) => {
    e.preventDefault();
    const element = document.getElementById('how-it-works');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pt-32 pb-20">
          <div className="absolute inset-0 bg-linear-to-b from-secondary to-secondary-dark opacity-50"></div>
          
          <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
                <span className="block mb-2">Your Life, Your Data, On Board with You</span>
                <span className="block text-primary-light">Emergency Health Info & Smart Financial Management</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-300 mb-12">
                OLAID helps you when it matters most. Share vital health data with first responders instantly via QR code in emergencies, 
                and effortlessly track shared expenses and cash flow. One account, two powerful apps.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4 px-4 sm:px-0 relative z-10">
                <a
                  href="https://app.olaid.me/create"
                  className="inline-flex justify-center items-center w-full sm:w-auto sm:min-w-[200px] bg-primary hover:bg-primary-dark text-white text-lg px-6 sm:px-8 py-3 sm:py-4 rounded-lg transition-colors duration-300 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary active:bg-primary-dark touch-manipulation"
                >
                  Get Started
                </a>
                <button
                  onClick={scrollToHowItWorks}
                  className="inline-flex justify-center items-center w-full sm:w-auto sm:min-w-[200px] bg-white/20 hover:bg-white/30 text-white text-lg px-6 sm:px-8 py-3 sm:py-4 rounded-lg transition-colors duration-300 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-white active:bg-white/40 touch-manipulation"
                >
                  How It Works
                </button>
              </div>
            </div>
          </div>
          
          <div className="absolute bottom-0 left-0 right-0 h-32 bg-linear-to-t from-gray-900 to-transparent z-0"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 